<template>
  <div class="p-6">
    <h3 class="text-[18px] font-bold text-grey-light-900">Cancellation Request</h3>
    <hr class="my-4" />
    <div class="flex flex-col items-center text-center">
      <Info class="w-10 h-10 text-brand-600 mb-4" />
      <p class="text-[14px] text-grey-light-700">Waiting for cancellation response from merchant.</p>
      <p class="text-[13px] text-grey-light-500 mt-2 italic">
        If you would like to recall and remove this cancellation request, select the Withdraw option below.
      </p>
    </div>
    <hr class="my-4" />
    <div class="flex gap-3">
      <Button
        variant="outline"
        class="flex-1 border-error-200 text-error-700 hover:text-error-700"
        :disabled="isSubmitting"
        @click="$emit('withdraw')"
      >
        Withdraw
      </Button>
      <Button variant="outline" class="flex-1" @click="$emit('close')">Close</Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { Info } from 'lucide-vue-next';

defineProps<{ isSubmitting: boolean }>();
defineEmits<{ withdraw: []; close: [] }>();
</script>
